import { useSearchParams } from 'react-router-dom'

/**
 * Stupid hack to make React Query respect changing search params
 * 
 * @param {URLSearchParamsInit|undefined} args - useSearchParams arguments
 * @returns {[object, function, function]} - searchParams, updateSearchParams, setSearchParams
 */
const useSearchParamsEx = (...args) => {
    
    const [searchParams, setSearchParams] = useSearchParams(...args)
    
    /**
     * 
     * @param {object|string} paramsOrKey - key string or object of key/value pairs
     * @param {*} [optionalValue] - optional value to set (if using a string key)
     * @returns {void}
     */
    const updateSearchParams = (paramsOrKey, optionalValue) => {
        
        const newParams = new URLSearchParams(searchParams)
        
        if (typeof paramsOrKey === 'string')
            newParams.set(paramsOrKey, optionalValue)
        else
            Object.keys(paramsOrKey).forEach(it => {
                newParams.set(it, paramsOrKey[it])
            })
        
        setSearchParams(newParams)
        
    }
    
    return [searchParams, updateSearchParams, setSearchParams]
    
}

export default useSearchParamsEx
